import { FileMedia, IFileMedia } from "./file-media.model";
import { GatewayPaymentUrl, IGatewayPaymentUrl } from "./gateway-payment-url.model";
import { PaymentMethod, IPaymentMethod } from "./payment-method.model";

export interface IMovement {
  movementId: string;
  neighborhoodId: string;
  streetBuildingId?: string;
  houseFlatId?: string;
  fileId?: string;
  description: string;
  notes: string;
  movementType: boolean;
  paymentMethodCode?: string;
  paymentMethod?: IPaymentMethod;
  status: boolean | null;
  creditApplied?: number;
  amount: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  image?: IFileMedia;
  gatewayPaymentUrls?: IGatewayPaymentUrl[];
}

export class Movement {
  movementId: string;
  neighborhoodId: string;
  streetBuildingId?: string;
  houseFlatId?: string;
  fileId?: string;
  description: string;
  notes: string;
  movementType: boolean;
  paymentMethodCode?: string;
  paymentMethod?: PaymentMethod;
  status: boolean | null;
  creditApplied?: number;
  amount: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  image?: FileMedia;
  gatewayPaymentUrls?: GatewayPaymentUrl[];

  constructor(data: IMovement) {
    this.movementId = data.movementId;
    this.neighborhoodId = data.neighborhoodId;
    this.streetBuildingId = data.streetBuildingId;
    this.houseFlatId = data.houseFlatId;
    this.fileId = data.fileId;
    this.description = data.description;
    this.notes = data.notes;
    this.movementType = data.movementType;
    this.paymentMethodCode = data.paymentMethodCode;
    this.paymentMethod = data.paymentMethod
      ? new PaymentMethod(data.paymentMethod)
      : undefined;
    this.status = data.status ?? null;
    this.creditApplied = data.creditApplied ?? 0;
    this.amount = data.amount;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.image = data.image
      ? new FileMedia(data.image)
      : undefined;
    this.gatewayPaymentUrls = data.gatewayPaymentUrls
      ? data.gatewayPaymentUrls.map(
          (item) => new GatewayPaymentUrl(item)
        )
      : undefined;
  }

  get movementTypeDescription(): string {
    return this.movementType ? 'Ingreso' : 'Gasto';
  }

  get statusDescription(): string {
    let value: string = '';

    if(this.movementType) {

      if(this.status === true) {
        value = 'Cobrado';
      } else {
        value = 'Pendiente';
      }

    } else {

      if(this.status === true) {
        value = 'Pagado';
      } else if(this.status === false) {
        value = 'Sin pago';
      } else {
        value = 'Pendiente';
      }

    }

    return value;
  }

}
